import { useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import { baseUrl } from "../../config/baseUrl";
import Swal from "sweetalert2";
import loaderContext from "../../context/LoaderContext";
import Pagination from "../Pagination/Pagination";
// import { isConditionalExpression } from "typescript";

export default function InsuranceHistory() {
  
  const [paginationDetails, setPaginationDetails] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
  });
  const [pageNumber, setPageNumber] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);

  const [applications, setApplications] = useState([]);

  const { setLoader } = useContext(loaderContext);

  useEffect(() => {
    fetchAllApplications();
  }, [pageNumber]);
  // console.log("applications", applications);

  const fetchAllApplications = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/admin/insurance/applications?page=${pageNumber}&limit=${pageLimit}`,
        // `http://localhost:3000/admin/insurance/applications?page=${pageNumber}&limit=${pageLimit}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      // console.log("response application", response);
      const { applications, pagination } = response?.data || {};

      
      setPaginationDetails({
        currentPage: pagination.page,
        totalPages: pagination.totalPages,
        totalItems: pagination.total,
      });
      setApplications(applications || []);
    } catch (error) {
      console.log("error", error);
      setApplications([]);
    }
  };

  return (
    <>
      <section className="main-sec">
        <div className="row">
          <div className="col-lg-6">
            <div className="dashboard-title">
              <h4 className="dash-head">
                <i className="fa fa-chart-bar me-2" />
                Insurance Applications
              </h4>
            </div>
            <div className="custom-bredcump">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Manage insurance applications and policies
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="cards bus-list">
              <div className="bus-filter">
                <div className="row align-items-center">
                  <div className="col-lg-6">
                    <h5 className="card-title">
                      Insurance History ({applications?.length || 0})
                    </h5>
                  </div>
                  {/* <div className="col-lg-6 text-end">
                                        <button
                                            className={`btn btn-outline-primary me-2 ${showFilters ? "active" : ""}`}
                                            onClick={() => setShowFilters(!showFilters)}
                                        >
                                            <i className="fa fa-filter me-1"></i>
                                            Filters
                                            {hasActiveFilters() && (
                                                <span className="badge bg-danger ms-1">{Object.values(filters).filter((v) => v).length}</span>
                                            )}
                                        </button>
                                        {hasActiveFilters() && (
                                            <button className="btn btn-outline-secondary" onClick={clearFilters}>
                                                <i className="fa fa-times me-1"></i>
                                                Clear
                                            </button>
                                        )}
                                    </div> */}
                </div>

                {/* Filter Panel */}
                {/* {showFilters && (
                                    <div className="filter-panel mt-3 p-3 bg-light rounded">
                                        <div className="row g-3">
                                            <div className="col-md-3">
                                                <label className="form-label">Course Name</label>
                                                <select
                                                    className="form-control"
                                                    value={filters.courseId}
                                                    onChange={(e) => handleFilterChange("courseId", e.target.value)}
                                                >
                                                    <option value="">All Courses</option>
                                                    {courseList?.map((course) => (
                                                        <option key={course._id} value={course._id}>
                                                            {course?.title}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label">Start Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={filters.startDate}
                                                    onChange={(e) => handleFilterChange("startDate", e.target.value)}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label">End Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={filters.endDate}
                                                    onChange={(e) => handleFilterChange("endDate", e.target.value)}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label">Status</label>
                                                <select
                                                    className="form-control"
                                                    value={filters.status}
                                                    onChange={(e) => handleFilterChange("status", e.target.value)}
                                                >
                                                    <option value="">All Status</option>
                                                    <option value="paid">Paid</option>
                                                    <option value="cancelled">Cancelled</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                )} */}

                {/* <div className="row mt-2">
                                    <div className="col-lg-12 text-end">
                                        <span className="text-muted">
                                            Showing {displayedHistory.length > 0 ? startIndex + 1 : 0} to{" "}
                                            {Math.min(endIndex, filteredHistory.length)} of {filteredHistory.length} entries
                                        </span>
                                    </div>
                                </div> */}
              </div>

              <div className="table table-responsive custom-table">
                <table className="table table-borderless">
                  <thead>
                    <tr>
                      {/* <th>Sr. no.</th> */}
                      <th>Policy No.</th>
                      <th>Owner Name</th>
                      <th>Animal</th>
                      <th>Coverage (₹)</th>
                      <th>Premium (₹)</th>
                      {/* <th>Provider</th> */}
                      <th>Status</th>
                      <th>Application Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {applications?.length > 0 ? (
                      applications.map((arr, i) => {
                        return (
                          <tr key={arr?._id || i}>
                            <td>{arr?.policyNumber || "N/A"}</td>
                            <td>{arr?.ownerId?.fullname || "N/A"}</td>
                            <td>{arr?.animalId?.breed || "N/A"}</td>
                            {/* <td>
                                                            <button
                                                                className="btn btn-link p-0 text-primary fw-bold"
                                                                onClick={() => handleInvoiceClick(arr)}
                                                                style={{
                                                                    textDecoration: "underline",
                                                                    border: "none",
                                                                    background: "none",
                                                                    cursor: "pointer",
                                                                }}
                                                                title="Click to view/print invoice"
                                                            >
                                                                {arr?.invoice || "N/A"}
                                                            </button>
                                                        </td> */}
                            {/* <td>
                                                            <span className="fw-medium">
                                                                {arr?.courseTitle ||
                                                                    arr?.courseName ||
                                                                    getCourseNameById(arr?.course_Id || arr?.course_id || arr?.courseId) ||
                                                                    "N/A"}
                                                            </span>
                                                        </td> */}
                            <td>{arr?.coverageAmount || "0"}</td>
                            <td>
                              <span className="fw-bold">
                                {arr?.premiumAmount || "0"}
                              </span>
                            </td>
                            {/* <td>
                              <span>{arr?.providerName || "N/A"}</span>
                            </td> */}
                            <td>
                              <span
                                className={
                                  // General Status
                                  arr?.status === "Active"
                                    ? "btn btn-pill btn-success btn-sm"
                                    : arr?.status === "Pending"
                                    ? "btn btn-pill btn-warning btn-sm"
                                    : arr?.status === "Approved"
                                    ? "btn btn-pill btn-primary btn-sm"
                                    : arr?.status === "Expired"
                                    ? "btn btn-pill btn-secondary btn-sm"
                                    : arr?.status === "Rejected"
                                    ? "btn btn-pill btn-danger btn-sm"
                                    : "btn btn-pill btn-dark btn-sm"
                                }
                              >
                                {arr?.status || "Unknown"}
                              </span>
                            </td>

                            <td>
                              <span>
                                {arr?.createdAt
                                  ? moment(arr.createdAt).format("DD/MM/YYYY")
                                  : "N/A"}
                              </span>
                              <br />
                              <small className="text-muted">
                                {arr?.createdAt
                                  ? moment(arr.createdAt).format("hh:mm A")
                                  : ""}
                              </small>
                            </td>
                            <td>
                              <div className="action-buttons">
                                <Link
                                  className="action-btn edit-btn bg-info"
                                  to={`/insurance-history/view/${arr?._id}`}
                                  title="View Details"
                                >
                                  <i className="fa fa-eye" />
                                </Link>
                                {/* <Link
                                  className="action-btn edit-btn bg-primary"
                                  to={`/purchase-history/edit/${arr?._id}`}
                                  title="Edit"
                                >
                                  <i className="fa fa-edit" />
                                </Link> */}
                                {/* <button
                                  className="action-btn edit-btn bg-danger border-0"
                                  title="Delete"
                                  onClick={() => {
                                    Swal.fire({
                                      title: "Are you sure?",
                                      text: "You won't be able to revert this!",
                                      icon: "warning",
                                      showCancelButton: true,
                                      confirmButtonColor: "#3085d6",
                                      cancelButtonColor: "#d33",
                                      confirmButtonText: "Yes, delete it!",
                                    }).then((result) => {
                                      if (result.isConfirmed) {
                                        // Add delete functionality here
                                        console.log("Delete:", arr?._id);
                                      }
                                    });
                                  }}
                                >
                                  <i className="fa fa-trash"></i>
                                </button> */}
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        {/* <td colSpan="9" className="text-center py-4">
                          <div className="no-data">
                            <i className="fa fa-inbox fa-3x text-muted mb-3"></i>
                            <h5 className="text-muted">
                              {hasActiveFilters()
                                ? "No Records Found"
                                : "No Purchase History Found"}
                            </h5>
                            <p className="text-muted">
                              {hasActiveFilters()
                                ? "Try adjusting your filters to see more results."
                                : "There are no purchase records to display."}
                            </p>
                            {hasActiveFilters() && (
                              <button
                                className="btn btn-primary btn-sm"
                                onClick={clearFilters}
                              >
                                <i className="fa fa-times me-1"></i>
                                Clear Filters
                              </button>
                            )}
                          </div>
                        </td> */}
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {paginationDetails.totalPages > 1 && (
                <Pagination
                  pageNumber={pageNumber}
                  totalPages={paginationDetails?.totalPages || 1}
                  setPageNumber={setPageNumber}
                  pageLimit={pageLimit}
                />
              )}
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .filter-panel {
          border: 1px solid #e0e0e0;
          animation: slideDown 0.3s ease-out;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .btn.active {
          background-color: #007bff;
          color: white;
          border-color: #007bff;
        }

        .action-buttons {
          display: flex;
          gap: 5px;
        }

        .action-btn {
          padding: 5px 8px;
          border-radius: 4px;
          text-decoration: none;
          color: white;
          font-size: 12px;
        }

        .sold-count {
          font-weight: bold;
          color: #007bff;
        }
      `}</style>
    </>
  );
}
